import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function useRemoveSearchParam(param, condition) {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (condition && searchParams.has(param)) {
      setSearchParams(
        (prev) => {
          const newParams = new URLSearchParams(prev);
          newParams.delete(param);
          return newParams;
        },
        { replace: true }
      );
    }
  }, [condition, param, searchParams, setSearchParams]);
}
